// extracted by mini-css-extract-plugin
module.exports = {"container":"TireSizeTextBlock_container__Z7oV2","title":"TireSizeTextBlock_title__bQqzi","code":"TireSizeTextBlock_code__Vbn1R","points":"TireSizeTextBlock_points__6cLO6"};